import {isAddress as ethersIsAddress} from "ethers";
import { removeEthFromContractAddress } from '../tokens/eth';

export function isAddress(address: string): boolean {
  return ethersIsAddress(removeEthFromContractAddress(address));
}
